module.exports = __webpack_public_path__ + "static/img/hsx22.387facc8.png";